export default __webpack_public_path__ + "static/media/uni2.7c6191d5.png";